import React from "react";

// Material UI
import SvgIcon from "@material-ui/core/SvgIcon";

const LayerTypePointIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M5 3C6.10457 3 7 3.89543 7 5C7 6.10457 6.10457 7 5 7C3.89543 7 3 6.10457 3 5C3 3.89543 3.89543 3 5 3Z"
        fill="currentColor"
      />
      <path
        d="M14 7C12.8954 7 12 7.89543 12 9C12 10.1046 12.8954 11 14 11C15.1046 11 16 10.1046 16 9C16 7.89543 15.1046 7 14 7Z"
        fill="currentColor"
      />
      <path
        d="M7 13C5.89543 13 5 13.8954 5 15C5 16.1046 5.89543 17 7 17C8.10457 17 9 16.1046 9 15C9 13.8954 8.10457 13 7 13Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default LayerTypePointIcon;
